import { createSlice } from '@reduxjs/toolkit';
import { fetchBalanceHistory, fetchCurrentBalance } from '../thunks/balanceThunks.js';

const initialState = {
    balance: 0,
    nextUpdate: '',
    history: {
        balanceHistory: [],
        maxPageNumber: 1,
        loading: false,
        error: null,
    },
    /**
     * full height in BalanceHistory view
     * */
    perPage: 13,
    loading: false,
    error: null,
};

const balanceSlice = createSlice({
    name: 'balance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBalanceHistory.pending, (state) => {
                state.history.loading = true;
                state.history.error = null;
            })
            .addCase(fetchBalanceHistory.fulfilled, (state, action) => {
                state.history.balanceHistory = action.payload.balanceHistory;
                state.history.maxPageNumber = action.payload.maxPageNumber;
                state.history.loading = false;
            })
            .addCase(fetchBalanceHistory.rejected, (state, action) => {
                state.history.loading = false;
                state.history.error = action.payload || action.error?.message;
            })
            .addCase(fetchCurrentBalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCurrentBalance.fulfilled, (state, action) => {
                state.balance = action.payload.current + action.payload.old;
                state.nextUpdate = action.payload.nextUpdate;
                state.loading = false;
            })
            .addCase(fetchCurrentBalance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message;
            })
            .addDefaultCase((state) => state);
    },
});

export default balanceSlice.reducer;
